import { computed, signal } from '@angular/core';
import { AgentTaskStatus } from 'AgentApp/ts/interfaces/agent-task.interface';
import * as i0 from "@angular/core";
const MOCK_PINNED_SESSIONS = [
    { id: 1, name: 'Replace a Holding in a Portfolio', icon: 'icon-pin-big', pinned: true, provider: 'anthropic' },
    { id: 2, name: 'Customize my dashboard', icon: 'icon-pin-big', pinned: true, provider: 'anthropic' },
    { id: 3, name: 'Customize Fundamental Chart', icon: 'icon-pin-big', pinned: true, provider: 'anthropic' },
    { id: 4, name: 'Compare AAPL vs MSFT Performance', icon: 'icon-pin-big', pinned: true, provider: 'anthropic' },
];
const MOCK_CHAT_SESSION_GROUPS = [
    {
        label: 'Recent',
        sessions: [
            {
                id: 10,
                name: 'A very long message which can take 2 or more lines depending of viewport size',
                icon: 'icon-ai-q',
                pinned: false,
                provider: 'anthropic',
            },
        ],
    },
    {
        label: 'Today',
        sessions: [
            {
                id: 11,
                name: 'Prepare for a Client Meeting',
                icon: 'icon-operator',
                pinned: false,
                provider: 'anthropic',
            },
            {
                id: 12,
                name: 'Replace a Holding in a Portfolio',
                icon: 'icon-ai-q',
                pinned: false,
                provider: 'anthropic',
            },
            {
                id: 13,
                name: 'Analyze sector allocation breakdown',
                icon: 'icon-ai-q',
                pinned: false,
                provider: 'anthropic',
            },
        ],
    },
    {
        label: 'Yesterday',
        sessions: [
            { id: 14, name: 'Run a Proposal Report', icon: 'icon-operator', pinned: false, provider: 'anthropic' },
            {
                id: 15,
                name: 'Prepare for a Client Meeting',
                icon: 'icon-operator',
                pinned: false,
                provider: 'anthropic',
            },
        ],
    },
    {
        label: 'Last Week',
        sessions: [
            {
                id: 16,
                name: 'Build a custom screener for mid-cap growth stocks',
                icon: 'icon-ai-q',
                pinned: false,
                provider: 'anthropic',
            },
            {
                id: 17,
                name: 'Generate risk metrics for portfolio',
                icon: 'icon-operator',
                pinned: false,
                provider: 'anthropic',
            },
        ],
    },
];
const MOCK_AGENT_TASKS = [
    {
        id: '1',
        status: AgentTaskStatus.COMPLETE,
        title: 'Risk/Reward Scatterplot',
        completed_at: '02/20/2026, 12:39 PM',
    },
    {
        id: '2',
        status: AgentTaskStatus.COMPLETE,
        title: 'AAPL Growth Metrics Fund Chart',
        completed_at: '02/20/2026, 12:39 PM',
    },
    { id: '3', status: AgentTaskStatus.IN_PROGRESS, title: 'Building scenario analysis model' },
    { id: '4', status: AgentTaskStatus.IN_PROGRESS, title: 'Creating Fund Chart' },
    { id: '5', status: AgentTaskStatus.CANCELLED, title: 'Creating Watchlist' },
];
export class AgentSessionStateService {
    constructor() {
        // TODO: replace mock data with HTTP requests
        this.pinnedSessions = signal(MOCK_PINNED_SESSIONS, ...(ngDevMode ? [{ debugName: "pinnedSessions" }] : []));
        this.chatSessionGroups = signal(MOCK_CHAT_SESSION_GROUPS, ...(ngDevMode ? [{ debugName: "chatSessionGroups" }] : []));
        this.allAgentTasks = signal(MOCK_AGENT_TASKS, ...(ngDevMode ? [{ debugName: "allAgentTasks" }] : []));
        this.visibleTasks = computed(() => this.allAgentTasks().filter((task) => !task.is_hidden), ...(ngDevMode ? [{ debugName: "visibleTasks" }] : []));
        this.completedTasks = computed(() => this.visibleTasks().filter((task) => task.status === AgentTaskStatus.COMPLETE), ...(ngDevMode ? [{ debugName: "completedTasks" }] : []));
        this.inProgressTasks = computed(() => this.visibleTasks().filter((task) => task.status === AgentTaskStatus.IN_PROGRESS), ...(ngDevMode ? [{ debugName: "inProgressTasks" }] : []));
        this.cancelledTasks = computed(() => this.visibleTasks().filter((task) => task.status === AgentTaskStatus.CANCELLED), ...(ngDevMode ? [{ debugName: "cancelledTasks" }] : []));
        this.hasInProgressTasks = computed(() => this.inProgressTasks().length > 0, ...(ngDevMode ? [{ debugName: "hasInProgressTasks" }] : []));
        this.taskCompletionPercentage = computed(() => {
            const total = this.visibleTasks().length;
            const completed = this.completedTasks().length;
            if (total === 0) {
                return 0;
            }
            return Math.round((completed / total) * 100);
        }, ...(ngDevMode ? [{ debugName: "taskCompletionPercentage" }] : []));
    }
    loadSessions() {
        // TODO: load chat sessions via API
    }
    selectSession(_session) {
        // TODO: load selected chat session messages via API
    }
    toggleSessionPin(_session) {
        // TODO: toggle pin status via API
    }
    deleteSession(_session) {
        // TODO: delete chat session via API
    }
    renameSession(_session) {
        // TODO: rename chat session via API
    }
    shareSession(_session) {
        // TODO: share chat session via API
    }
    selectTask(_task) {
        // TODO: navigate to task
    }
    deleteTask(task) {
        this.allAgentTasks.update((tasks) => tasks.filter((t) => t.id !== task.id));
    }
    hideTask(task) {
        this.allAgentTasks.update((tasks) => tasks.map((t) => (t.id === task.id ? { ...t, is_hidden: true } : t)));
    }
}
AgentSessionStateService.ɵfac = function AgentSessionStateService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentSessionStateService)(); };
AgentSessionStateService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AgentSessionStateService, factory: AgentSessionStateService.ɵfac, providedIn: 'root' });
